export const prices = [
    {
        id: 0,
        name: 'Todos'
    },
    {
        id: 1,
        name: '1K - 19K'
    },
    {
        id: 2,
        name: '20K - 39K'
    },
    {
        id: 3,
        name: '40K - 59K'
    },
    {
        id: 4,
        name: '60K - 79K'
    },
    {
        id: 5,
        name: 'Mas de 80K'
    }
]